import LOGO from "../images/add_icon.svg";
import FirstPageDataTableIcon from "../images/arrow_first.svg";
import LastPageDataTableIcon from "../images/arrow_last.svg";
import PreviousPageIcon from "../images/arrow_left.svg";
import NextPageIcon from "../images/arrow_right.svg";
import AssetSidebar from "../images/asset_sidebar.svg";
import Key from "../images/authentication_method.svg";
import AuthenticatorApp from "../images/authenticator_app.svg";
import BlackPlus from "../images/black_plus.svg";
import CallVerification from "../images/call_verification.svg";
import CopyToClipboard from "../images/copy_to_clipboard.svg";
import CrossIcon from "../images/cross_icon.svg";
import DiscoveryHeading from "../images/discovery_svg.svg";
import DotIcon from "../images/dot_icon.svg";
import EMAIL from "../images/email.svg";
import ExportIcon from "../images/export.svg";
import FirstPageIcon from "../images/first_page.svg";
import GoogleAuthenticator from "../images/google_authenticator.png";
import GroupHeadingIcon from "../images/group_icon.svg";
import HardwareToken from "../images/hardware_token.svg";
import HashiCorp_Icon from "../images/hashicorp_icon.svg";
import Hide_Text_Eye_Icon from "../images/hide.svg";
import InfoIcon from "../images/icon-info.svg";
import KeePass_Icon from "../images/keepass.svg";
import LastPageIcon from "../images/last_page.svg";
import MiniorangeAuthenticator from "../images/miniorange_authenticator.svg";
import NotAllowedMethods from "../images/not_allowed_methods.svg";
import passwordInfoIcon from "../images/password_info_icon.svg";
import PasswordPolicyIcon from "../images/password_policy_icon.svg";
import Plus from "../images/plus.svg";
import Columns from "../images/policy_columns.svg";
import Database from "../images/policy_database.svg";
import PolicyPlus from "../images/policy_plus.svg";
import PolicySidebarIcon from "../images/policy_sidebar_icon.svg";
import Table from "../images/policy_table.svg";
import Server from "../images/policy_server.svg";
import SecurityQuestion from "../images/security_question.svg";
import settingInfoIcon from "../images/setting_dark_tool_tip.svg";
import Show_Text_Eye_Icon from "../images/show.svg";
import SMS from "../images/sms.svg";
import SystemUserHeadingIcon from "../images/systemuserheadingicon.svg";
import ThreeDotIcon from "../images/three_dot.svg";
import Tick from "../images/tick.svg";
import TicketIcon from "../images/ticket_sidebar.svg";
import TwoFactorSidebarIcon from "../images/two_factor_sidebar_icon.svg";
import Upload from "../images/upload.svg";
import WebAppHeading from "../images/web_app_heading.svg";
import WebAppSidebar from "../images/web_app_sidebar.svg";
import UserHeadingIcon from "../images/User_heading_icon.svg";
import AddCircleOutline from "../images/add_circle_outline.svg";
import assetHeadingIcon from "../images/all_asset_icon.svg";
import S3 from "../images/amazon-s3_logo.png";
import AuthyAuthenticator from "../images/authy_authenticator.png";
import AWS from "../images/AWS.svg";
import AWS_Icon from "../images/aws_icon.svg";
import Azure_Icon from "../images/azure_icon.svg";
import Loader from "../images/black_loader.svg";
import check_coloured from "../images/check_coloured.svg";
import Cloudinary from "../images/cloudinary_logo.png";
import ContactUs from "../images/contactus-x.svg";
import Delete from "../images/delete.svg";
import deletePasswordPolicyAction from "../images/delete_password_policy_action.svg";
import DragIndicator from "../images/drag_indicator.svg";
import DropBox from "../images/dropbox_logo.png";
import Edit from "../images/edit.svg";
import editPasswordPolicyAction from "../images/edit_password_policy_action.svg";
import GoDaddy from "../images/go_daddy.svg";
import {
  default as GoogleCloud,
  default as Googlecloud,
} from "../images/google-cloud_logo.png";
import GridIcon from "../images/grid_icon.svg";
import Biometric from "../images/biometric.svg";
import { default as Hide, default as HideEyeIcon } from "../images/hide.svg";
import ContactUsLoader from "../images/loader.svg";
import MicrosoftAuthenticator from "../images/microsoft_authenticator.png";
import Azure from "../images/microsoft_azure.svg";
import MongoDb from "../images/mongodb.png";
import NetworkAnalyzer from "../images/network_analyzer.svg";
import Onboard from "../images/onboard.svg";
import Onboarded from "../images/onboarded.svg";
import passwordPolicyCreateSign from "../images/password_policy_create_plus_sign.svg";
import AzureWebapp from "../images/ResourceIcons/azure.svg";
import cmd from "../images/ResourceIcons/cmd.svg";
import control_panel from "../images/ResourceIcons/control_panel.svg";
import customWebApp from "../images/ResourceIcons/custom_webapp.svg";
import file_explorer from "../images/ResourceIcons/file_explorer.svg";
import JIRA from "../images/ResourceIcons/jira.svg";
import kubernetes from "../images/ResourceIcons/kubernetes.svg";
import linux from "../images/ResourceIcons/linux.svg";
import microsoftOffice from "../images/ResourceIcons/microsoft-office.svg";
import microsoft_edge from "../images/ResourceIcons/microsoft_edge.svg";
import mssql from "../images/ResourceIcons/mssql.svg";
import mysql from "../images/ResourceIcons/mysql.svg";
import notepad from "../images/ResourceIcons/notepad.svg";
import oracle from "../images/ResourceIcons/oracle.svg";
import paint from "../images/ResourceIcons/paint.svg";
import pssql from "../images/ResourceIcons/postgresql.svg";
import powershell from "../images/ResourceIcons/powershell.svg";
import rdp from "../images/ResourceIcons/rdp.svg";
import registry_editor from "../images/ResourceIcons/registry_editor.svg";
import sap from "../images/ResourceIcons/sap.svg";
import sftp from "../images/ResourceIcons/sftp.svg";
import ftp from "../images/ResourceIcons/ftp.svg";
import slack from "../images/ResourceIcons/slack.png";
import smb from "../images/ResourceIcons/smb.svg";
import vnc from "../images/ResourceIcons/vnc.svg";
import windows from "../images/ResourceIcons/windows.svg";
import windows_media_player from "../images/ResourceIcons/windows_media_player.svg";
import telnet from "../images/ResourceIcons/telnet.svg";
import plc from "../images/ResourceIcons/plc.svg";
import hmi from "../images/ResourceIcons/hmi.svg";
import scada from "../images/ResourceIcons/scada.svg";
import industrial_switch from "../images/ResourceIcons/industrial_switch.svg";
import engineering_station from "../images/ResourceIcons/engineering_station.svg";
import { default as Show, default as ShowEyeIcon } from "../images/show.svg";
import Authentication from "../images/sso.svg";
import SSOAddNewAttribute from "../images/sso_add_new_attribute.svg";
import SSORemoveAttribute from "../images/sso_remove_attribute.svg";
import TrashIcon from "../images/trash_icon.svg";
import UpperArrowIcon from "../images/upper_arrow_icon.svg";
import SIEMIcon from "../images/siem_logs.svg";
import VaultDropdownIndicator from "../images/vault-select-dropdown-indicator.svg";
import WebIcon from "../images/web.svg";
import SFTP from "../images/sftp.svg";
import Error400 from "../images/error_400.svg"
import PeopleIcon from "../images/peoples.svg";
// Database GUI Icons
import Error400DatabaseGui from "../images/database-gui/400.svg";
import AlibabaOSS from "../images/object-storage-oss.svg";

import arista from "../images/arista.png";
import array from "../images/array.png";
import barracuda from "../images/barracuda.png";
import checkpoint from "../images/checkpoint.png";
import cisco_asa from "../images/cisco-asa.png";
import edgecore from "../images/edgecore.png";
import palo_alto from "../images/palo-alto.png";
import sonicwall from "../images/sonicwall.png";
import sophos from "../images/sophos.png";
import watchguard from "../images/watchguard.png";

const images = {
  Error400,
  AlibabaOSS,
  DropBox,
  S3,
  MongoDb,
  Cloudinary,
  Azure,
  Googlecloud,
  LOGO,
  PreviousPageIcon,
  NextPageIcon,
  ExportIcon,
  FirstPageIcon,
  GroupHeadingIcon,
  LastPageIcon,
  Plus,
  ThreeDotIcon,
  SystemUserHeadingIcon,
  UserHeadingIcon,
  Upload,
  Key,
  AuthenticatorApp,
  Biometric,
  FIDO2Tools: Biometric,
  CallVerification,
  CopyToClipboard,
  CrossIcon,
  EMAIL,
  HardwareToken,
  MiniorangeAuthenticator,
  SMS,
  SecurityQuestion,
  GoogleAuthenticator,
  Tick,
  TwoFactorSidebarIcon,
  NotAllowedMethods,
  DotIcon,
  PolicyPlus,
  BlackPlus,
  Database,
  Server,
  Hide,
  Show,
  Table,
  PolicySidebarIcon,
  Columns,
  InfoIcon,
  TicketIcon,
  WebAppSidebar,
  WebAppHeading,
  AssetSidebar,
  PasswordPolicyIcon,
  passwordInfoIcon,
  settingInfoIcon,
  Hide_Text_Eye_Icon,
  Show_Text_Eye_Icon,
  GoogleCloud,
  AWS_Icon,
  Azure_Icon,
  HashiCorp_Icon,
  KeePass_Icon,
  Authentication,
  NetworkAnalyzer,
  Onboarded,
  Onboard,
  Delete,
  Edit,
  UpperArrowIcon,
  DragIndicator,
  AddCircleOutline,
  TrashIcon,
  SSOAddNewAttribute,
  SSORemoveAttribute,
  ContactUs,
  ContactUsLoader,
  Loader,
  FirstPageDataTableIcon,
  LastPageDataTableIcon,
  passwordPolicyCreateSign,
  editPasswordPolicyAction,
  deletePasswordPolicyAction,
  VaultDropdownIndicator,
  ShowEyeIcon,
  HideEyeIcon,
  check_coloured,
  MicrosoftAuthenticator,
  AuthyAuthenticator,
  SIEMIcon,
  SFTP,
  WebIcon,
  GridIcon,
  DiscoveryHeading,
  GoDaddy,
  AWS,
  windows,
  linux,
  vnc,
  mysql,
  pssql,
  oracle,
  kubernetes,
  mssql,
  sap,
  customWebApp,
  microsoftOffice,
  JIRA,
  AzureWebapp,
  slack,
  notepad,
  cmd,
  rdp,
  control_panel,
  file_explorer,
  microsoft_edge,
  paint,
  powershell,
  registry_editor,
  windows_media_player,
  sftp,
  ftp,
  assetHeadingIcon,
  smb,
  PeopleIcon,
  telnet,
  plc,
  hmi,
  scada,
  industrial_switch,
  engineering_station,
  // Database GUI Icons
  Error400DatabaseGui,
  arista,
  array,
  barracuda,
  checkpoint,
  cisco_asa,
  edgecore,
  palo_alto,
  sonicwall,
  sophos,
  watchguard,
};

export default images;
